var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m10.8 24.2a4.6 4.6 0 0 1 9.2 0z",
  fill: "#f2c14e"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 9.8,
  y: 23.7,
  width: 11.2,
  height: 1.6,
  rx: 0.8,
  fill: "#e0a52f"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 22,
  y: 21,
  width: 4.2,
  height: 2.8,
  rx: 1.2,
  fill: "#46626d"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 26.9,
  y: 21,
  width: 4.2,
  height: 2.8,
  rx: 1.2,
  fill: "#46626d"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m26.2 22.2h0.7",
  fill: "none",
  stroke: "#46626d",
  strokeWidth: 1
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m8 25.5 -4.2-4.8h6.2l3 4.8z",
  fill: "#d99a3f"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m33 25.5 4.2-4.8h-6.2l-3 4.8z",
  fill: "#d99a3f"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  y: 25.5,
  width: 25,
  height: 11.5,
  rx: 1.2,
  fill: "#c8925a"
});

var _ref10 = /*#__PURE__*/React.createElement("circle", {
  cx: 37.5,
  cy: 8.5,
  r: 6,
  fill: "#23967f"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m40.8 8.5a3.3 3.3 0 1 1-3.3-3.3",
  fill: "none",
  stroke: "#ffffff",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m37.3 3.5 3.2 1.7-3.2 1.7z",
  fill: "#ffffff"
});

function SvgRefillPpe(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 45 45",
    viewBox: "0 0 45 45",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefillPpe);
export default __webpack_public_path__ + "static/media/refill-ppe.36e785c57163a8f5b43506199d5fe9f7.svg";
export { ForwardRef as ReactComponent };